import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import WOW from "wowjs";
import axios from 'axios';

function Team() {
    const [teamMembers, setTeamMembers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const wow = new WOW.WOW({ live: false });
        wow.init();
    }, []);

    useEffect(() => {
        axios.get('https://solanthegroup.com/admin/api/teams')
            .then(response => {
                setTeamMembers(response.data);
                setLoading(false);
            })
            .catch(error => {
                setError("Failed to load team members.");
                setLoading(false);
            });
    }, []);

    if (loading) return <p className="text-center"></p>;
    if (error) return <p className="text-center text-danger">{error}</p>;

    return (
        <div>
            <div className="team-area tmp-section-gap bg-white">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="section-head">
                                <div className="section-sub-title center-title">
                                    <img src="assets/images/services/section-custom-menubar.png" alt="Corporate services" />
                                    <span>OUR EXPERT TEAM</span>
                                </div>
                                <h2 className="section-title split-collab">Meet Our Expert Team</h2>
                            </div>
                        </div>
                    </div>
                    <div className="row g-5 justify-content-center">
                        {teamMembers.map((member, index) => (
                            <div key={member.id} className={`col-lg-4 col-md-6 col-sm-12 col-12 wow fadeInLeft`} data-wow-duration=".8s" data-wow-delay={`.${index + 1}s`}>
                                <div className="single-team">
                                    <div className="thumbnail"
                                    >
                                        <img src={`https://solanthegroup.com/admin/${member.photo}`} alt={member.name} 
                                        style={{height:"350px",objectFit:"cover"}}/>
                                    </div>
                                    <div className="content">
                                        <div className="team-name content-with-bg">
                                            <div className="name-area">
                                                <h6 className="name">{member.name}</h6>
                                            </div>
                                            <div className="designation">{member.position}</div>
                                        </div>
                                        <div className="share-icon-style-one">
                                            <ul className="social-icons social-icons-with-bg">
                                                {member.facebook && (
                                                    <li><a href={member.facebook} target="_blank" rel="noopener noreferrer"><i className="fa-brands fa-facebook-f" /></a></li>
                                                )}
                                                {member.linkedin && (
                                                    <li><a href={member.linkedin} target="_blank" rel="noopener noreferrer"><i className="fa-brands fa-linkedin-in" /></a></li>
                                                )}
                                                {member.twitter && (
                                                    <li><a href={member.twitter} target="_blank" rel="noopener noreferrer"><i className="fa-brands fa-twitter" /></a></li>
                                                )}
                                            </ul>
                                            <i className="fa-sharp fa-solid fa-share-nodes" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Team;
